(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();

      this.addEventListener('slider:init', this.initSlider.bind(this));
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      // Destroy existing slider if it exists
      if (this.slider) {
        this.slider.destroy();
      }

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 16,
      };
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
